import React from 'react'
import styles from './index.module.less'

function Header() {
  return (
    <div className={styles.header}>
      <em className={styles.banner}></em>
    </div>
  )
}

export default Header
